<template>
  <Select
    :items="representantes"
    :selectedItem="filter.representante"
    label="Representante"
    searchPlaceholder="Buscar representante"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        representante: {
          id: "",
          name: "",
        },
      },
      representantes: [],
    };
  },
  methods: {
    atualizar(representante) {
      this.filter.representante = representante || { id: '', name: '' };

      const valor = this.filter.representante.id;
      this.$aplicaFiltroEmURL(this.filtro.filtro, valor, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: valor
      });
    },
  },
  mounted() {
    this.$api.get('/pessoas/busca_vendedores').then((response) => {
      this.representantes = response.data.map(pessoa => ({
        id: pessoa.id,
        name: pessoa.label
      }));

      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.representantes, this.filter.representante);
    }).catch(error => exibe_erro(error.response?.data?.message || error.message));
  },
}
</script>
